/* ===========================================================================
   New item
   =========================================================================== */

import { hideClass, visibleClass } from '../settings/settings';
import {$searchForm, $searchTriggers, Search} from "./search";

var runSearch = function (e) {
  e.preventDefault();

  const search = new Search();
  search.submit();
};

/**
 * [updateFilter description]
 * @param  {[type]} data  [description]
 * @param  {[type]} $elem [description]
 * @return {[type]}       [description]
 */
function updateFilter(data, $elem) {
  const $form = $('.js-dynamic-filter-form');
  const type = $form.prop('id') === 'js-search-form' ? 'search' : 'new_item';

  if (typeof data === 'object' && 'content' in data) {
    data = data.content;
  }

  let $newOptions = $(data).find($elem).html();
  if (type === 'search') {
    let isChecked = [...new Set($($elem).find('input:checked').map(function( index ) {
      return $( this ).next('label').html();
    }).get())];
    let parent = $(data).find($elem);
    let childLi = $(parent).children('li');
    let labels = [];

    childLi.each(function () {
      let label = labels.find(o => o.label === $(this).find('label').html());
      if (label) {
        let $idToAdd = $(this).find('input').val();
        $(label.input).val($(label.input).val()+','+$idToAdd);
        if(isChecked !== 'undefined' && isChecked.length > 0 && isChecked.includes(label.label)) {
          $(label.input).attr('checked', true);
        }
        $(parent).find($(this)).remove();
      }
      labels.push({ label : $(this).find('label').html(), input : $(this).find('input')});
    });
    $newOptions = $(parent).html();
  }

  let element = $($elem);
  $($elem).html($newOptions);

  createActiveFilters();
  clickResetFilters();
  document.querySelector('#js-observer-categories .js-accordion-research').addEventListener('click', runSearch);

  if (element[0].childNodes) {
    if (element[0].childNodes.length > 1) {
      $($elem).removeAttr('disabled');
    } else {
      $($elem).prop('disabled', true);
    }
  }
}

function createActiveFilters() {
  const searchFilterResult = $("#js-search-filter-result");
  if (searchFilterResult.length) {
    const activatedFiltersContainer = $('.search-filters-active-container');
    const checkedInputs = searchFilterResult.find('input[type=checkbox]:checked');
    const town = document.getElementById('filter_shop');
    const townValue = town.value;
    checkedInputs.each(function() {
      const parentEl = $(this).parents('.search-filter-filter');
      const activeFiltersInside = parentEl.find('input[type=checkbox]:checked').length;
      const parentLabel = parentEl.find('.js-accordion-header label');
      activeFiltersInside ? parentLabel.attr('data-filters', activeFiltersInside) : '';
      const labelText = $(this).next('label').text();
      const targetId = $(this).attr('id');
      const activatedFilter = $('<label for="'+targetId+'" class="search-filter-active">'+ labelText +'</label>');
      activatedFiltersContainer.prepend(activatedFilter);
      activatedFilter.on('click', (e) => {
        e.preventDefault();
        document.getElementById(e.target.getAttribute('for')).checked = false;
        new Search().submit();
      });
    });

    if (townValue) {
      const selectContainer = $('#select2-filter_shop-container');
      const activatedFilter = $('<button type="button" class="search-filter-active">'+ selectContainer.attr('title') +'</button>');
      activatedFiltersContainer.prepend(activatedFilter);
      activatedFilter.on('click', () => {
        $(town).val('').trigger('change');
        new Search().submit();
      });
    }
  }

  $('.search-filters-active-container').hide();
}

function clickResetFilters() {
  const $brandField = $('#filter_brand');
  const $resetButtons = $('#js-reset-search, .js-accordion-reset');
  $resetButtons.each(function() {
    $(this).on('click', function (e) {
      const isAccordionReset = $(this).hasClass('js-accordion-reset');
      const targetParent = isAccordionReset ? $(this).parents('ul') : $($searchForm);
      const checkedInputs = targetParent.find('input:checked');
      const filterShop = $('#filter_shop');

      if (checkedInputs.length > 0 || filterShop.val() !== '') {
        checkedInputs.length ? checkedInputs.each(function() {
          $(this).removeAttr('checked');
        }) : '';
        filterShop.val('').trigger('change');
        new Search().submit();
      } else {
        return false;
      }
    });
  });
}

function updateAttribute(data) {
  const $form = $('.js-dynamic-filter-form');
  const type = $form.prop('id') === 'js-search-form' ? 'search' : 'new_item';

  let attributes = $('.js-attribute');
  attributes.each(function () {
    $(this).addClass(hideClass).removeClass(visibleClass);
  });

  const searchFilterMoreTrigger = $('.js-search-filter-more');
  const filterSign = searchFilterMoreTrigger.find('.filter-more-sign');

  searchFilterMoreTrigger.click(() => {
    if (attributes.filter('.'+ hideClass).length > 0) {
      attributes.each(function () {
        $(this).removeClass(hideClass);
      });
      filterSign.text('-');
    } else {
      attributes.each(function () {
        $(this).addClass(hideClass);
      });
      filterSign.text('+');
    }
  });

  if (typeof data === 'object' && 'content' in data) {
    data = data.content;
  }

  let attributesToDisplay = $(data).find('.js-category').data('attributes');
  if (attributesToDisplay) {
    attributesToDisplay = attributesToDisplay.split('/');

    if (type === 'search') {
      attributes.each(function () {
        for (var i = 0; i < attributesToDisplay.length; i++) {
          if ($(this).hasClass(attributesToDisplay[i])) {
            $(this).closest('div').removeClass(hideClass);
            $(this).closest('div').addClass(visibleClass);
            break;
          }
        }
      });
    }
    else {
        attributes.each(function () {
          if ($(this).prop('id') && $.inArray($(this).prop('id'), attributesToDisplay) !== -1) {
            $(this).closest('div').removeClass(hideClass);
            $(this).closest('div').addClass(visibleClass);
          }
        });
      }
  }
}

function updateSuggestedPrice(value) {
    $('.suggested-price-value').html(value);
}

function updateBreadCrumb() {
  const gender_values = $("ul.js-gender input[name='filter[gender][]']:checked");
  const range_values = $("ul.js-range input[name='filter[range][]']:checked");
  const category_values = $("ul.js-category input[name='filter[category][]']:checked");

  if (gender_values && gender_values.length === 1 && range_values && (range_values.length <= 1)) {
    let regex = /(([\w]+\/){2})([^\/]+)/gm;
    let str = $('#breadcrumb_gender').prop('href');
    let subst = `$1`+$(gender_values[0]).val();

// The substituted value will be contained in the result variable
    let result = str ? str.replace(regex, subst) : '';
    $('#breadcrumb_gender').prop('href', result).html($(gender_values[0]).next('label').html());
    $('#breadcrumb_range').parent('.breadcrumb-item').hide();
    result = $('#breadcrumb_range').prop('href').replace(/(([\w]+\/){2})(([\w]+\/))([^\/]+)/gm, `$1`+$(gender_values[0]).val()+'/$5');
    $('#breadcrumb_range').prop('href', result);
    $('#breadcrumb_category').parent('.breadcrumb-item').hide();
    $('#breadcrumb_gender').parent('.breadcrumb-item').show();
  }
  if (range_values && range_values.length === 1 && gender_values && gender_values.length === 1 && category_values.length <= 1) {
    let regex = /(([\w]+\/){3})([^\/]+)/gm;
    const str = $('#breadcrumb_range').prop('href');
    const subst = `$1`+$(range_values[0]).val();

// The substituted value will be contained in the result variable
    const result = str.replace(regex, subst);
    $('#breadcrumb_range').prop('href', result).html($(range_values[0]).next('label').html());
    $('#breadcrumb_range').parent('.breadcrumb-item').show();
  }
  if (category_values && category_values.length === 1 && range_values && range_values.length === 1) {
    $('#breadcrumb_category').html($(category_values[0]).next('label').html());
    $('#breadcrumb_category').parent('.breadcrumb-item').show();
  }
}

function updateSizeFilter(data) {
  let $range = $('.js-range');
  let elemClass = '.js-size';
  let $elem = $(elemClass);

  updateFilter(data, elemClass);

  if ($range.val() != "") {
      $($elem).removeAttr('disabled');
  } else {
      $($elem).prop('disabled', true);
  }

  if($elem.attr('id') !== undefined) {
    document.getElementById($elem.attr('id')).dispatchEvent(new Event("change"));
  }
}

function hideGenderDisclaimer() {
    $('#js-gender-disclaimer').addClass(hideClass);
}

function updateDeliveryOnRemunerationChange(remunerationSelectBox)
{
  if ($(remunerationSelectBox).val() === 'cash') {
    $('#delivery').hide().addClass('not-active');
    $('#p2s_new_item_deliveryMethod_0').attr('checked', 'checked');
    $('#p2s_edit_item_deliveryMethod_0').attr('checked', 'checked');
    $('#p2s_new_item_deliveryMethod_1').removeAttr('checked');
    $('#p2s_edit_item_deliveryMethod_1').removeAttr('checked');
  } else {
    $('#delivery').show().removeClass('not-active');
    $('#p2s_new_item_deliveryMethod_1').removeAttr('checked');
    $('#p2s_edit_item_deliveryMethod_1').removeAttr('checked');
  }
}

function selectDeliveryFromRemuneration($elem)
{
  let remuneration = $($elem).val();
  const buttonStepNext = '.js-step-next';
  const deliverySection = '#delivery';

  if ($(deliverySection).hasClass('delivery-certified-form') || $(deliverySection).hasClass('edit-delivery')) {
    $(deliverySection).find(buttonStepNext).attr('disabled', false).addClass('button-animate');
  } else {
    if (remuneration === 'cash') {
      $(deliverySection).find(buttonStepNext).attr('disabled', false).removeClass('button-animate');
    }
  }

  $('#delivery_methods input').each(function(){
    let appliedTo = $(this).data('applied');
    if (appliedTo.includes(remuneration)) {
      $(this).parent('.checkbox-wrapper').show();
    } else {
      $(this).parent('.checkbox-wrapper').hide();
    }

    $("#p2s_new_item_deliveryMethod_0").attr({
      "checked": "checked",
      "disabled": "disabled"
    });
    $("#p2s_edit_item_deliveryMethod_0").attr({
      "checked": "checked",
      "disabled": "disabled"
    });

    if (remuneration === 'cash') {
        $('#p2s_new_item_deliveryMethod_1').removeAttr('checked');
        $('#p2s_edit_item_deliveryMethod_1').removeAttr('checked');
        $('#delivery_methods').hide();
        $('#shops_info').hide();
        $('#cash_label').show();

        $('#shops').hide();
        $('#shops').prop('disabled', true);
        $('#shops').find('select').prop('required', false);
    } else {
      $('#delivery_methods').show();
      $('#shops_info').show();
      $('#cash_label').hide();

      if ($('#p2s_new_item_deliveryMethod_1').is(':checked')) {
        $('#shops').show();
        $('#shops').prop('disabled', false);
        $('#shops').find('select').prop('required', true);
        return;
      }
      if ($('#p2s_edit_item_deliveryMethod_1').is(':checked')) {
        $('#shops').show();
        $('#shops').prop('disabled', false);
        $('#shops').find('select').prop('required', true);
        return;
      }
    }
  });
}

/**
 * [initFilterSellForm description]
 * @return {[type]} [description]
 */
export function initFilterSellForm() {

    const $form = $('.js-dynamic-filter-form');
    const url = $form.data('partial-description-action');
    const type = $form.prop('id') === 'js-search-form' ? 'search' : 'new_item';
    let controller;
    let signal;

    // on document ready
    $(document).ready(function() {
      selectDeliveryFromRemuneration($('.js-remuneration'));

      // Simulate form data, but only include the relevant values.
      if (type === 'search') {
        const data = {};

        let $category =  $('.js-category input:checked');
        let $range = $('.js-range input:checked');
        let $gender = $('.js-gender input:checked');

        data[$category.attr('name')] = $category.val();
        data[$range.attr('name')] = $range.map(function( index ) {
          return $( this ).val();
        }).get();
        data[$gender.attr('name')] = $gender.val();

        // Submit data via AJAX to the form's action path.
        $.ajax({
          url : url,
          type: $form.attr('method'),
          data : data,
          success: function(data) {
            updateFilter(data.html, '.js-range');
            updateAttribute(data.html);
            $('.search-filters-active-container').show();
          }
        });
      }

      if ($('.js-vue-price').length) {
        const itemPrice = $('.js-vue-price').val();
        if (itemPrice.length > 0) {
          calculateVoucherAmount(itemPrice);
        }
      }
    });

    // on remuneration change
  $form.on('change', '.js-remuneration', function(event) {
    updateDeliveryOnRemunerationChange($(this));
    selectDeliveryFromRemuneration($(this));
  });

  $form.on('keyup', ".js-vue-price", function(event) {
    calculateVoucherAmount($(this).val());
  });

  function calculateVoucherAmount(number) {
    const createProductForm = $("form[name='p2s_new_item']");
    const editProductForm = $("form[name='p2s_edit_item']");
    const remunerationMethod = $(".js-remuneration");
    const isCertifiedItem = (createProductForm.length > 0 && createProductForm.hasClass("new-certified-product-form"))
      || (editProductForm.length > 0 && editProductForm.hasClass("edit-certified-product-form"));
    if (isCertifiedItem) remunerationMethod.removeAttr("disabled");

    const option = remunerationMethod.find('option[value="voucher"]').html();
    const regExp = /\(([^)]+)\)/;
    const price = parseFloat(number.replace('€', '').replace(' ', '').replace(',', '.')) * 1.3;

    if (!isNaN(price)) {
      const html = option.replace(new RegExp(regExp), '(' + (Math.round(price * 100) / 100).toFixed(2).toString().replace('.', ',') + '€)');
      remunerationMethod.find('option[value="voucher"]').html(html);
      $('.l-dropdown').find('[data-value="voucher"]').html(html);
    }
    if (isCertifiedItem) remunerationMethod.attr("disabled", "disabled");
  }

    // delivery method
  $form.on('change', "input[type=checkbox][name='p2s_new_item[deliveryMethod][]'], input[type=checkbox][name='p2s_edit_item[deliveryMethod][]']",  function(event) {
    $(this).each(function(){
      $('#shops').hide();
      $('#shops').prop('disabled', true);
      $('#shops').find('select').prop('required', false);
    });

    let checkedValues = $("input:checked[type=checkbox][name='p2s_new_item[deliveryMethod][]'], input:checked[type=checkbox][name='p2s_edit_item[deliveryMethod][]']");
    let toDisplay = false;

    checkedValues.each(function() {
      if ($(this).data('attribute') === 'stores') {
        toDisplay = true;
        $('#shops').show();
        $('#shops').prop('disabled', false);
        $('#shops').find('select').prop('required', true);
        return;
      }
    });

    if (!toDisplay) {
      let checkedValue = $(this).prop('checked');
      let attribute = $(this).data('attribute');

      if (checkedValue && attribute) {
        $('#shops').prop('disabled', false);
        $('#shops').show();
      }
    }
  });

  if (type === 'search') {
    const controllerCreation = () => {
      if (controller !== undefined) {
        controller.abort();
      }

      if (AbortController) {
        controller = new AbortController;
        signal = controller.signal;
      }
    };
    // on gender change
    $form.on('change', '.js-gender',  function(event) {
      controllerCreation();

      var formData = new FormData();

      var genderIds = $('input[name="filter[gender][]"]:checked').map(function() {return this.value; }).get();
      formData.append('filter[gender][]', genderIds);

      fetch(url, {
        method: $form.attr('method'),
        body: formData,
        signal: signal
      })
        .then(response => response.json())
        .then(data => {
          updateFilter(data.html, '.js-range');
          updateSizeFilter(data.html);
          updateAttribute(data.html);
          updateBreadCrumb();
        })
        .catch(err => {
          if (err.name !== 'AbortError') {
            console.log(err);
          }
        });
    });

    //  on range change
    $form.on('change', '.js-range',  function() {
      controllerCreation();

      const formData = new FormData(document.getElementById('js-search-form'));
      let allRanges = formData.getAll('filter[range][]');
      var ranges = [];
      allRanges.forEach(function (values) {
        if (values.includes(",")) {
          let valuesSplitted = values.split(',');
          valuesSplitted.forEach(function(value) {
            ranges.push(value);
          });
        } else {
          ranges.push(values);
        }
      });

      var genders = $('input[name="filter[gender][]"]:checked').map(function() {return this.value; }).get();
      formData.append('filter[gender][]', genders);
      formData.append('filter[range][]', ranges);

      fetch(url, {
        method: $form.attr('method'),
        body: formData,
        signal: signal
      })
        .then(response => response.json())
        .then(data => {
          updateFilter(data.html, '.js-category');
          updateFilter(data.html, '.js-size');
          updateAttribute(data.html);
          updateBreadCrumb();
        })
        .catch(err => {
          if (err.name !== 'AbortError') {
            console.log(err);
          }
        });
    });

    // on category change
    $form.on('change', '.js-category',  function(event) {
      controllerCreation();

      let formData = new FormData();
      let $gender = $('.js-gender');
      let $range = $('.js-range');
      let $brand = $('.js-brand');

      formData.append($gender.prop('name'),$gender.val());
      formData.append($range.prop('name'),$range.val());
      formData.append($brand.prop('name'),$brand.val());
      formData.append($(this).attr('name'), $(this).val());

      fetch(url, {
        method: $form.attr('method'),
        body: formData,
        signal: signal
      })
        .then(response => response.json())
        .then(data => {
          hideGenderDisclaimer();
          updateBreadCrumb();
        })
        .catch(err => {
          if (err.name !== 'AbortError') {
            console.log(err);
          }
        });
    });
  }

  $form.on('change', '.js-brand',  function() {
    const brandId = $('.js-brand').attr('id');
    if (brandId) {
      document.getElementById(brandId).dispatchEvent(new Event("change"));
    }
  });

  $form.on('change', '.js-size',  function() {
    const sizeId = $('.js-size').attr('id');
    if (sizeId) {
      document.getElementById(sizeId).dispatchEvent(new Event("change"));
    }
  });
}
